<template>
  <v-content>
    <v-container
      class="pl-0 mt-2 ma-0"
      fluid
      align-content="start"
      justify="center"
    >
    <pageTitle
      style="display:block"
    >
      Sign Up & Log In
    </pageTitle>
    <div
      class="ml-0"
      id="firebaseui-auth-container"
    ></div>
    </v-container>
  </v-content>
</template>

<script>
import service from '@/plugins/service'
import firebase from "firebase/app"
import "firebase/firestore"
import "firebase/auth"
import "firebaseui"
import 'firebaseui/dist/firebaseui.css'
import pageTitle from '@/components/Like/PageTitle'

export default {
  components: {
    pageTitle,
  },
  async mounted() {
    // 認証状態をブラウザに保存する(スマホ前提。ログイン回数を減らす努力)。
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
    //
    const baseUrl = location.href.substring(0,
      location.href.length - location.pathname.length);
    let ui = firebaseui.auth.AuthUI.getInstance()
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth())
    }
    // 認証ウィンドウを描画。
    const signInOptions = [
      firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      firebase.auth.PhoneAuthProvider.PROVIDER_ID,
    ]
    // 遷移先を作成
    const next = this.$route.params.next
    const param = this.$route.params.param
    const path = [next]
    if (param) {
      path.push(param)
    }
    // Fireabase Auth画面を開く
    ui.start("#firebaseui-auth-container", {
      signInSuccessUrl: `${baseUrl}/${path.join('/')}`,
      signInOptions: signInOptions,
      tosUrl: `${baseUrl}/en/tos`,
      privacyPolicyUrl: `${baseUrl}/en/privacy`,
    })
  },
}
</script>

<style lang="stylus">
.firebaseui-idp-list
  padding-left 0 !important
</style>
